import { types } from '../../../types/types';

export const reducerNetWorkErrors = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.ERROR_NETWORK:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}